import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {getChildren} from '@packages/utilities/data-utils';

const View = Atom.createRender(
  ({data, generateAttributes, attributes, classes, renderChild}) => {
    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'.
    const Tag = data.tag ?? 'div';
    return (
      <Tag {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child) => renderChild(child))}
      </Tag>
    );
  }
);

export default View;
